import { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import GroupPage from "@/pages/GroupPage";
import NetworkPage from "@/pages/NetworkPage";
import SolutionsPage from "@/pages/SolutionsPage";
import VideoPage from "@/pages/VideoPage";
import LegalPage from "@/pages/LegalPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // GTM: SPA pageview tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: pathname,
      page_title: document.title,
    });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || ""}>
        <SmoothScroll>
          <div className="App grain min-h-screen bg-black text-white">
            <Navbar />
            <ScrollToTop />
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/gruppo" element={<GroupPage />} />
                <Route path="/network" element={<NetworkPage />} />
                <Route path="/soluzioni" element={<SolutionsPage />} />
                <Route path="/video-e-format" element={<VideoPage />} />
                <Route path="/disclaimer" element={<LegalPage docKey="disclaimer" />} />
                <Route path="/privacy-policy" element={<LegalPage docKey="privacy-policy" />} />
                <Route path="/cookie-policy" element={<LegalPage docKey="cookie-policy" />} />
                <Route path="/codice-etico" element={<LegalPage docKey="codice-etico" />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
